import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "shadow-600 log-in-logs border-radius-1" }
const _hoisted_2 = { class: "app-security content-box mt-4 px-0 pt-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "padding-inner" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Security")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "w-100 pt-3 mt-2"
}
const _hoisted_5 = { class: "app-security-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "change-password-wrapper"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "change-password" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " Generate a new password for this user. Once log into app with this pass, we will ask user to create a new password. ", -1)
const _hoisted_10 = { class: "password mt-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "password-label" }, "Generated Password", -1)
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "password" }, " VGH-hu7-JNKl ", -1)
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Copy", -1)
const _hoisted_16 = { class: "mt-3 pt-1" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Generate New Pass", -1)
const _hoisted_19 = {
  key: 0,
  class: "social-connected w-100 d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeadToolBar = _resolveComponent("HeadToolBar")!
  const _component_SecurityLog = _resolveComponent("SecurityLog")!
  const _component_tab_panel = _resolveComponent("tab-panel")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ConnectedSocial = _resolveComponent("ConnectedSocial")!
  const _component_tab_panels = _resolveComponent("tab-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_HeadToolBar, {
        tabs: _ctx.tabsList,
        onChangeTab: _ctx.changeTab
      }, null, 8, ["tabs", "onChangeTab"]),
      _createVNode(_component_tab_panels, {
        modelValue: _ctx.selectedTab.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTab.title) = $event)),
        animate: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tab_panel, { val: "Log In Logs" }, {
            default: _withCtx(() => [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.selectedTab?.title === 'Log In Logs')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapedloginHistory, (login, idx) => {
                            return (_openBlock(), _createBlock(_component_SecurityLog, {
                              key: login.id,
                              "device-name": login.deviceName,
                              "device-o-s": login.deviceOS,
                              "device-type": login.deviceType,
                              "connect-location": login.connectLocation,
                              "connect-time": login.connectDate,
                              "is-current-session": idx === 0 ?? true
                            }, null, 8, ["device-name", "device-o-s", "device-type", "connect-location", "connect-time", "is-current-session"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_tab_panel, { val: "Password Change" }, {
            default: _withCtx(() => [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.selectedTab?.title === 'Password Change')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("img", {
                          class: "change-password-image",
                          src: require('@/assets/img/secure-human.svg'),
                          alt: "Secure"
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _createVNode(_component_AppButton, {
                                type: "primary",
                                size: "xs"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_svg_icon, {
                                      icon: "copy",
                                      class: "me-1"
                                    }),
                                    _hoisted_15
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_AppButton, {
                              type: "danger",
                              size: "fluid"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Send to Email ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_AppButton, {
                              type: "primary-transparent",
                              size: "fluid"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_svg_icon, {
                                    class: "me-2 d-block",
                                    icon: "reload"
                                  }),
                                  _hoisted_18
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_tab_panel, { val: "Connected Socials" }, {
            default: _withCtx(() => [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.selectedTab?.title === 'Connected Socials')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_ConnectedSocial)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}